import API_URLS from '../../constants/api-urls';
import axios from '../../utils/axios';

type RemoveDuplicatedFromCartResponse = { data: { items: { cart: Cart } } };

export const removeDuplicatedFromCart = (): Promise<Cart> =>
    (axios.get(`${API_URLS.CART}remove-duplicated`) as unknown as Promise<RemoveDuplicatedFromCartResponse>).then(
        (response) => response.data.items.cart
    );
